/**
 * 平台运营租户（临时硬编码）。
 * 后续会替换为独立的平台管理员角色/权限体系。
 */
export const PLATFORM_OPERATOR_TENANT_UUID = '73256cb3220e44b683d8add58ae11185';

export const isPlatformOperatorTenant = (tenantUuid?: string | null) =>
  Boolean(tenantUuid && tenantUuid === PLATFORM_OPERATOR_TENANT_UUID);

export const assertPlatformOperatorTenant = (tenantUuid?: string | null) => {
  if (!isPlatformOperatorTenant(tenantUuid)) {
    throw new Error('当前企业无权访问平台治理功能');
  }
};
